import { ModuleData } from '../../Types/containerV2';
import { isBizAgentModuleContent } from '../../Types/containerV2/modules/bizAgent';
import { BizAgentWidget } from '../../../Modules/BizAgent';
import './BizAgentModule.scss';

type BizAgentModuleProps = {
	module: ModuleData;
};

const BizAgentModule = ({ module }: BizAgentModuleProps) => {
	const content = isBizAgentModuleContent(module.content) ? module.content : null;
	const configSystemName = content?.configSystemName?.trim();

	if (!configSystemName) {
		return null;
	}

	return (
		<div className='biz-module biz-agent-container-module'>
			<BizAgentWidget configSystemName={configSystemName} inlineMode={true} />
		</div>
	);
};

export default BizAgentModule;

